'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const get = require('lodash.get');
const classnames = require('classnames');
const css = require('./personalizationStyle.scss');
const copy = require('./personalizationCopy.json');
const tracking = require('../../helpers/tracking.es');

function onItemClick(item, trackingObj) {
    tracking.trackPersonalizationPromoClick();
    tracking.trackPersonalizationItemClick(item, trackingObj);
}

function viewAllClick(variant) {
    tracking.trackPersonalizationPromoClick();
    tracking.trackPersonalizationViewAll(variant);
}

function PersonalizationPanelMainItem(props) {
    const itemUrl = get(props.item, 'pdpUrls[0]');
    const image = get(props.item, 'images[0].medium');
    const viewAllClass = classnames(css.viewAll, {
        'button-medium button-naked': props.isMobile
    });
    const trackingObj = {
        variant: props.variant,
        category: props.categoryUrl,
        position: 0
    };

    return (
        <div className={`colXs12 colXl6 ${css.flexItem}`}>
            <div className={`${css.itemContainer} ${css.isMain}`}>
                <div className={`h1 ${css.categoryTitle}`}>{props.categoryTitle}</div>
                <a className={css.mainImageContainer} href={itemUrl} onClick={() => onItemClick(props.item, trackingObj)}>
                    <img alt={props.item.title} className={css.mainItemImage} src={image} />
                </a>
                <a href={props.categoryUrl} className={viewAllClass} onClick={() => viewAllClick(props.variant)}>{copy.viewAll}</a>
            </div>
        </div>
    );
}

PersonalizationPanelMainItem.propTypes = {
    item: PropTypes.object.isRequired,
    categoryUrl: PropTypes.string.isRequired,
    categoryTitle: PropTypes.string.isRequired,
    variant: PropTypes.string.isRequired,
    isMobile: PropTypes.bool
};

module.exports = PersonalizationPanelMainItem;



// WEBPACK FOOTER //
// ./assets/js/home/components/personalization/PersonalizationPanelMainItem.jsx